import script from "./PanelStoreSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./PanelStoreSettings.vue?vue&type=script&setup=true&lang=js"

import "./PanelStoreSettings.vue?vue&type=style&index=0&id=ddbbfd1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddbbfd1a"]])

export default __exports__